// extracted by mini-css-extract-plugin
export default {"bridgeSessionPage":"BridgeSessionPage_bridgeSessionPage__eo39+"};